import {
    DefaultEyebrowLogo,
    DefaultLogo,
    WhiteEyebrowLogo,
    WhiteLogo
} from "./components";

export type LogoTrelloProps = {
    eyebrow?: boolean;
    height?: number;
    width?: number;
    appearance?: "white" | "blue";
    id?: string;
};

export const LogoTrello = ({
    eyebrow,
    height,
    width,
    appearance,
    id = ""
}: LogoTrelloProps) => {
    const intrinsicWidth = 312;
    const intrinsicHeight = eyebrow ? 105 : 64;

    let actualWidth = width;
    let actualHeight = height;

    if (!width && height) {
        actualWidth = (intrinsicWidth / intrinsicHeight) * height;
    } else if (width && !height) {
        actualHeight = (intrinsicHeight / intrinsicWidth) * width;
    } else if (!width && !height) {
        actualWidth = intrinsicWidth;
        actualHeight = intrinsicHeight;
    }

    const props = {
        id,
        actualHeight,
        actualWidth,
        intrinsicHeight,
        intrinsicWidth
    };

    if (appearance === "white") {
        if (eyebrow) {
            return <WhiteEyebrowLogo {...props} />;
        }
        return <WhiteLogo {...props} />;
    }

    if (eyebrow) {
        return <DefaultEyebrowLogo {...props} />;
    }

    return <DefaultLogo {...props} />;
};
